/** Action-level permission keys (granted via Access & permissions or Roles). */
export const LOI_STAGE_UPDATE = 'action.loi-stage.update';
export const AGREEMENT_STAGE_UPDATE = 'action.agreement-stage.update';
